
export default class UserOutPSP {
	constructor() {
		this.appKey = undefined
		this.firstName = undefined
		this.lastName = undefined
		this.login = undefined
		this.email = undefined
		this.phone = undefined
		this.facility = undefined
	}

	static default() {
		return User.buildFromJson({

		})
	}

	static buildFromJson(user = undefined) {
		if(user !== undefined) {
			var result = new UserOutPSP()
			result.appKey = user.appKey
			result.firstName = user.firstName
			result.lastName = user.lastName
			result.email = user.email
			result.phone = user.phone
			result.facility = user.facilities && user.facilities.name ? user.facilities.name : null;
			result.login = user.email
			return result
		}
		return undefined
	}
}



// WEBPACK FOOTER //
// ./src/model/UserOutPSP.js